<script lang="ts">
  import { locale, LOCALES, tStore, type Locale } from '../i18n'

  function pick(next: Locale) {
    locale.set(next)
  }

  const LABELS: Record<Locale, string> = {
    en: 'EN',
    hr: 'HR',
  }
</script>

<div class="lang" role="group" aria-label={$tStore('header.languageSwitcher')}>
  {#each LOCALES as code (code)}
    <button
      type="button"
      class="lang__btn"
      class:lang__btn--active={$locale === code}
      aria-pressed={$locale === code}
      onclick={() => pick(code)}
    >
      {LABELS[code]}
    </button>
  {/each}
</div>

<style lang="scss">
  @use '../assets/styles/variables' as v;

  .lang {
    display: inline-flex;
    border: 1px solid v.$color-border;
    border-radius: v.$radius-sm;
    overflow: hidden;
  }

  .lang__btn {
    appearance: none;
    border: none;
    background: transparent;
    padding: 0.25rem 0.5rem;
    font-size: 0.75rem;
    font-weight: 600;
    letter-spacing: 0.02em;
    color: v.$color-text-muted;
    cursor: pointer;
    transition:
      background-color 120ms ease,
      color 120ms ease;

    & + & {
      border-left: 1px solid v.$color-border;
    }

    &:hover {
      background: v.$color-surface;
      color: v.$color-text;
    }
  }

  .lang__btn--active {
    background: v.$color-surface;
    color: v.$color-text;
  }
</style>
